import dayjs from 'dayjs';

import { ExportWinStreaksFormValues } from './types';

export const INITIAL_EXPORT_WIN_STREAKS_VALUES: ExportWinStreaksFormValues = {
  startDate: dayjs(),
  endDate: dayjs().add(1, 'day'),
  limit: 10,
};
